// src/pages/Admin/GpxUpload.tsx
import React, { useState, useEffect } from 'react';

export interface GpxUploadProps {
  productId: string;
  disabled: boolean;
  onUploadSuccess?: () => void;
}

const GpxUpload: React.FC<GpxUploadProps> = ({ productId, disabled, onUploadSuccess }) => {
  const [file, setFile] = useState<File | null>(null);
  const [msg, setMsg]   = useState<string>('');

  const API = process.env.REACT_APP_API_HOST ||
    'https://virtualchallenge-platform-3edceab55a5f.herokuapp.com';

  useEffect(() => {
    setMsg('');
  }, [productId]);

  const submit = async () => {
    if (!productId || !file) {
      setMsg('Product ID and file required');
      return;
    }
    const data = new FormData();
    data.append('productId', productId);
    data.append('gpx', file);

    try {
      const res = await fetch(`${API}/medalmad/gpxtojson/`, {
        method: 'POST',
        body: data,
      });
      if (!res.ok) throw new Error(await res.text());
      setMsg('GPX file uploaded successfully.');
      onUploadSuccess?.();
    } catch (e: any) {
      setMsg(`Error: ${e.message}`);
    }
  };

  return (
    <div className="card border-secondary h-100">
      <div className="card-header bg-secondary text-white">
        Upload GPX File
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label htmlFor="gpx-file" className="form-label">
            Select GPX File
          </label>
          <input
            id="gpx-file"
            type="file"
            accept=".gpx"
            className="form-control"
            onChange={e => setFile(e.target.files?.[0] ?? null)}
            disabled={disabled}
          />
        </div>
        <button
          className="btn btn-primary"
          onClick={submit}
          disabled={disabled}
        >
          Upload
        </button>
        {msg && <div className="mt-2 alert alert-info">{msg}</div>}
      </div>
    </div>
  );
};

export default GpxUpload;
